import React, { useEffect, useState } from "react";
import Image from "next/image";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
  Dot,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

import { useDesktopMediaQuery } from "../../utils/helpers";
import IMAGES from "../constants/images";
import ICONS from "../constants/icons";
import ZoomSlide from "../ZoomSlide/ZoomSlide";
import customImageLoader from "../../utils/imageloader";

import styles from "./productImages.module.css";
import { Product } from "../../commonTypes";

interface Props {
  product: Product;
}

const ProductImages = ({ product }: Props) => {
  const isDesktop = useDesktopMediaQuery();
  const images = product.images;
  const defaultImage = IMAGES.PRODUCTDEFAULT;

  // useEffect(() => {
  //   setMainImage(images ? images[0] : defaultImage);
  // }, [images, defaultImage]);

  const handleImageClick = ({ url }) => {};

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <CarouselProvider
          naturalSlideWidth={1}
          naturalSlideHeight={1}
          infinite
          totalSlides={images?.length || 1}
        >
          <div className={styles.mainImage}>
            {images && images.length > 1 && (
              <div className={styles.carouselButtons}>
                <ButtonNext className={styles.buttonNext}>
                  <ICONS.ARROWUP size={35} />
                </ButtonNext>
                <ButtonBack className={styles.buttonBack}>
                  <ICONS.ARROWUP size={35} />
                </ButtonBack>
              </div>
            )}
            <Slider>
              {images.map((image, index) => {
                if (isDesktop) {
                  return (
                    <ZoomSlide
                      key={`${image}-${index}`}
                      image={image}
                      index={index}
                      defaultImage={defaultImage}
                    />
                  );
                } else {
                  return (
                    <Slide
                      innerClassName={styles.slide}
                      key={index}
                      index={index}
                    >
                      {/* <div className={styles.imageContainer}> */}
                      <img
                        src={image ? image : defaultImage}
                        style={{ width: "100%", aspectRatio: "1 / 1" }}
                        // height={1}
                        // width={1}
                        // layout="responsive"
                        alt="product image"
                      />
                      {/* </div> */}
                    </Slide>
                  );
                }
              })}
            </Slider>
            <DotGroup className={styles.dotGroup} />
          </div>
          <div className={styles.imageGrid}>
            {images &&
              images.map((image, index) => {
                return (
                  isDesktop && (
                    <Dot key={index} slide={index} className={styles.imageItem}>
                      <Image
                        src={image}
                        height={1}
                        width={1}
                        loading="eager"
                        layout="responsive"
                        alt="product image"
                        loader={customImageLoader}
                      />
                    </Dot>
                  )
                );
              })}
          </div>
        </CarouselProvider>
      </div>
    </div>
  );
};

export default ProductImages;
